import { NgTemplateOutlet } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { RealProperty } from "@eemo/api-client";
import { ModalBaseComponent } from "../base/modal-base/modal-base.component";

export class PropertyTransferInfoDialogData {
  prop: RealProperty;
}

@Component({
  selector: "app-property-transfer-info-dialog",
  standalone: true,
  templateUrl: "./property-transfer-info-dialog.component.html",
  styleUrl: "./property-transfer-info-dialog.component.scss",
  imports: [ModalBaseComponent, NgTemplateOutlet, MatDialogModule],
})
export class PropertyTransferInfoDialogComponent {
  dialogTitle = "Transfert du dossier à votre client";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PropertyTransferInfoDialogData
  ) {}
}
